import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import spacing from 'src/constants/spacing';
import mediaQueries from 'src/constants/responsive';
import PanelText from './Panels/PanelText';
import * as classNames from 'classnames';
import PanelSubTitle from './Panels/PanelSubTitle';
import PanelImages from './Panels/PanelImages';
import PanelInfoBox from './Panels/PanelInfoBox';
import PanelVideo from './Panels/PanelVideo';
import PanelReference from './Panels/PanelReference';
import PanelLabel from './Panels/PanelLabel';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            [mediaQueries.Mobile]: {},
            [mediaQueries.AfterMobile]: {
                display: 'flex',
                flexWrap: 'wrap',
            },
            [mediaQueries.Tablet]: {
            },
            [mediaQueries.Laptop]: {
            },
            [mediaQueries.Desktop]: {
            },
        },
        panel: {
            width: '100%',
            boxSizing: 'border-box',
            [mediaQueries.Mobile]: {
                marginBottom: spacing.Gutter.Mobile,
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
                marginBottom: spacing.Gutter.Tablet,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.Gutter.Laptop / 2,
                paddingRight: spacing.Gutter.Laptop / 2,
                marginBottom: spacing.Gutter.Laptop,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.Gutter.Desktop / 2,
                paddingRight: spacing.Gutter.Desktop / 2,
                marginBottom: spacing.Gutter.Desktop,
            },
        },
        panelHalf: {
            [mediaQueries.AfterMobile]: {
                width: '50%',
            },
        },
        panelThird: {
            [mediaQueries.TabletPortrait]: {
                width: '50%',
            },
            [mediaQueries.TabletLandScape]: {
                width: `${100 / 3}%`,
            },
            [mediaQueries.AfterTablet]: {
                width: `${100 / 3}%`,
            },
        },
        panelSubtitle: {
            width: '100%',
            boxSizing: 'border-box',
            [mediaQueries.Mobile]: {
                marginBottom: spacing.Gutter.Mobile * 2,
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
                marginBottom: spacing.Gutter.Tablet,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.Gutter.Laptop / 2,
                paddingRight: spacing.Gutter.Laptop / 2,
                marginBottom: spacing.Gutter.Laptop,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.Gutter.Desktop / 2,
                paddingRight: spacing.Gutter.Desktop / 2,
                marginBottom: spacing.Gutter.Desktop,
            },
        },
        panelLabels: {
            width: `${100 / 3}%`,
            [mediaQueries.Mobile]: {
                width: '50%',
            },
            [mediaQueries.TabletPortrait]: {
                width: '50%',
            },
        }
    }));

export type PanelsProps = {
    panels: IDto[];
    isProductPage?: boolean;
};
type Props = PanelsProps;

const Panels: FC<Props> = ({ panels, isProductPage }) => {
    const cls = useStyles();

    return (
        <div className={cls.root}>
            {panels.map((panel, i) => {
                switch (panel.type) {
                    case "PanelText":
                        const p = panel as PanelTextDto;
                        return (
                            <div
                                key={`${p.type}-${i}`}
                                className={classNames(cls.panel,
                                    p.Size === "Half" && cls.panelHalf,
                                    p.Size === "Third" && cls.panelThird)
                                }
                            >
                                <PanelText {...p} />
                            </div>);

                    case "PanelSubTitle":
                        const panelSubTitle = panel as PanelSubTitleDto;
                        return (
                            <div
                                key={`${panelSubTitle.type}-${i}`}
                                className={
                                    classNames(
                                        cls.panelSubtitle,
                                        panelSubTitle.Size === "Half" && cls.panelHalf,
                                        panelSubTitle.Size === "Third" && cls.panelThird)
                                }
                            >
                                <PanelSubTitle {...panelSubTitle} />
                            </div>);

                    case "PanelImages":
                        const panelImages = panel as PanelImagesDto;
                        return (
                            <div
                                key={`${panelImages.type}-${i}`}
                                className={classNames(cls.panel,
                                    panelImages.Size === "Half" && cls.panelHalf,
                                    panelImages.Size === "Third" && cls.panelThird)
                                }
                            >
                                <PanelImages {...panelImages} />
                            </div>);

                    case "PanelInfoBox":
                        const panelInfoBox = panel as PanelInfoBoxDto;
                        return (
                            <div
                                key={`${panelInfoBox.type}-${i}`}
                                className={classNames(cls.panel,     
                                    panelInfoBox.Size === "Half" && cls.panelHalf,
                                    panelInfoBox.Size === "Third" && cls.panelThird)
                                }
                            >
                                <PanelInfoBox {...panelInfoBox} />
                            </div>);

                    case "PanelVideo":
                        const panelVideo = panel as PanelVideoDto;
                        return (
                            <div
                                key={`${panelVideo.type}-${i}`}
                                className={classNames(cls.panel, 
                                    panelVideo.Size === "Half" && cls.panelHalf,
                                    panelVideo.Size === "Third" && cls.panelThird)
                                }
                            >
                                <PanelVideo {...panelVideo} />
                            </div>);

                    case "PanelReference":
                        const panelReference = panel as PanelReferenceDto;
                        return (
                            <div
                                key={`${panelReference.type}-${i}`}
                                className={cls.panel}
                            >
                                <PanelReference
                                    {...panelReference}
                                    isProductPage={isProductPage} />
                            </div>);

                    case "PanelLabel":
                        const panelLabel = panel as PanelLabelDto;
                        return (
                            <div
                                key={`${panelLabel.type}-${i}`}
                                className={classNames(cls.panel, 
                                    panelLabel.Size === "Half" && cls.panelHalf,
                                    panelLabel.Size === "Third" && cls.panelThird)
                                }
                            >
                                <PanelLabel {...panelLabel} />
                            </div>);

                    default:
                        return null;
                }
            })}
        </div>
    );
}

export default Panels;


// WEBPACK FOOTER //
// ./src/Components/Panels.tsx